import $ from "jquery";
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

let swiperInstance = null;

function initInterviewSwiper() {
  const $swiperContainer = $('.js-interviewSwiper');
  const slideCount = $swiperContainer.find('.swiper-slide').length;
  const windowWidth = window.innerWidth;

  // クラスのリセット
  $swiperContainer.removeClass('-inactivePc -inactiveSp');

  // Swiperが既に存在していたら破棄
  if (swiperInstance) {
    swiperInstance.destroy(true, true);
    swiperInstance = null;
  }

  // 共通Swiperオプション
  const swiperOptions = {
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
    },
    centeredSlides: true,
    loop: true,
    navigation: {
      nextEl: ".js-interviewSwiper .swiper-button-next",
      prevEl: ".js-interviewSwiper .swiper-button-prev",
    },
    pagination: {
      clickable: true,
      el: ".js-interviewSwiper .swiper-pagination",
    },
    slidesPerView: "auto",
    spaceBetween: 0,
  };

  if (windowWidth >= 768) {
    // PC
    if (slideCount >= 4) {
      swiperInstance = new Swiper(".js-interviewSwiper", swiperOptions);
    } else {
      $swiperContainer.addClass('-inactivePc');
    }
  } else {
    // SP
    if (slideCount >= 2) {
      swiperInstance = new Swiper(".js-interviewSwiper", swiperOptions);
    } else {
      $swiperContainer.addClass('-inactiveSp');
    }
  }
}

// 初期化
$(document).ready(function () {
  initInterviewSwiper();
});

// resize（リサイズ）時の対応 with debounce
let resizeTimer;
$(window).on('resize', function () {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(() => {
    initInterviewSwiper();
  }, 300); // debounce: 300ms
});
